import { render, staticRenderFns } from "./BatchBalanceTable.vue?vue&type=template&id=d1c2b074"
import script from "./BatchBalanceTable.vue?vue&type=script&lang=js"
export * from "./BatchBalanceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports